module.exports = __webpack_public_path__ + "img/piaget-altiplano-ultimate-910p-3.410c21c3.png";